export default {
    mode: 'history',
}
